module.exports = __webpack_public_path__ + "img/logo_ppdb_v2.8ab02ada.png";